export default {
  name: 'mcCard',
  props: {
    hover: {
      type: String,
      default: 'showBorder'   // showBorder 主色边框    showMask  模板&操作按钮
    },
    clickTarget: {
      type: String,
      default: 'card'   // showBorder 主色边框    showMask  模板&操作按钮
    },
    btnText: {
      type: String,
      default: ''
    },
    isImgRound: {
      type: Boolean,
      default: false
    },
    imgUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }

  },
  render(h){
    return h('h1',{

    }, this.$slots.default)
  }
}


// WEBPACK FOOTER //
// ./src/components/card.js